import { exportReport } from 'partner360/services/report/exportReport'

const BUSINESS_PRIORITIES_EXPORT_ENTRY_ID = 285

/**
 * Downloads the business priorities Excel report. The backend mapping takes no keys:
 * its view always returns the current fiscal year, so `fYear` only names the file.
 */
export const exportBusinessPriorities = (fYear: number) =>
  exportReport({
    filename: `Business Priorities_FY${String(fYear).slice(-2)}.xlsx`,
    entryId: BUSINESS_PRIORITIES_EXPORT_ENTRY_ID,
    mappings: {},
  })
